import { render, staticRenderFns } from "./SubscriptionUpgrade.vue?vue&type=template&id=46b95290&scoped=true&"
import script from "./SubscriptionUpgrade.vue?vue&type=script&lang=js&"
export * from "./SubscriptionUpgrade.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionUpgrade.vue?vue&type=style&index=0&id=46b95290&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b95290",
  null
  
)

export default component.exports